/**
 * @file     SxLink.tsx
 * @purpose  A next/link styled with MUI sx, usable from Server Components. A server file cannot
 *           pass `component={Link}` to Box (a function cannot cross the client boundary), so it
 *           renders this instead with a plain sx object.
 */
'use client';

import Link from 'next/link';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

export function SxLink({ href, sx, children, ...rest }: { href: string; sx?: SxProps<Theme>; children: ReactNode; 'aria-label'?: string }) {
  return (
    <Box component={Link} href={href} sx={sx} {...rest}>
      {children}
    </Box>
  );
}
